import request from '@/util/request'

export function listFiles () {
  return request({
    url: '/noauth/file/list',
    method: 'get'
  })
}

export function deleteFile (id) {
  return request({
    url: '/noauth/file/delete?id=' + id,
    method: 'delete'
  })
}



// WEBPACK FOOTER //
// ./src/api/fileshare.js